import React from 'react';
import './Page.css';

function OurGoals() {
  return (
    <div className="page">
      <div className="page-content">
        <div className="section-heading">
          <div className="accent-line" aria-hidden="true"></div>
          <h1>Our Goals</h1>
        </div>
        <ul className="goals-list">
          <li>Generate top tier long-term risk adjusted returns</li>
          <li>Build deep relationships with long-term oriented, like-minded investors</li>
          <li>Create a best-in-class boutique investment partnership dedicated to India: single product, single strategy, capped AUM, low fee.</li>
        </ul>
        <p>
          Our investment strategy is to buy high quality businesses with a margin of safety and hold them for a long duration. 
          Our portfolio is built with deep bottom-up, fundamentals-based research and is benchmark agnostic.
        </p>
      </div>
    </div>
  );
}

export default OurGoals;
